/* ------------------------------------------------------------------------------
@name: Custom Script
@description: If want custom script in here
--------------------------------------------------------------------------------- */

const cart = {
  add: function (data, always) {
    $.post(window.Shopify.routes.root + 'cart/add.js', data, false, 'json').always(always);
  },
};

const search = {};

const notification = {
  init: function () {
    var container = $('#notifications');

    if (!container.length) {
      container = $('<div id="notifications"></div>');
      container.appendTo('body');
    }
  },
  add: function (type, message) {
    notification.init();

    var container = $('#notifications');
    var item = $('<div class="notification"></div>"');

    item.addClass(type).html(message).prependTo(container);

    setTimeout(function () {
      item.fadeOut(500, function () {
        item.remove();
      });
    }, 5000);
  },
};

const sectionHeader = function () {
  var output = {};
  var search = {
    desktop: {
      init: function () {
        search.desktop.trigger();
      },
      toggle: function ($section) {
        var search = $('.header__search-desktop', $section);
        search.toggleClass('show');
      },
      trigger: function () {
        $(document).on('click', 'header.header .searchToggle', function () {
          var $section = $(this).parents('header.header');
          if ($section) search.desktop.toggle($section);
        });
      },
    },
  };

  search.desktop.init();

  return output;
};

const sectionProduct = function () {
  var output = {};
  var addToCart = {
    init: function () {
      addToCart.loader();
      addToCart.trigger();
    },
    change: function ($section) {
      var variants = JSON.parse($('.jsonVariants', $section).html());
      var quantities = JSON.parse($('.jsonQuantities', $section).html());
      var option1 = $('input[name="option1"]:checked', $section).val();
      var option2 = $('input[name="option2"]:checked', $section).val();
      var option3 = $('input[name="option3"]:checked', $section).val();

      if (!option1) option1 = null;
      if (!option2) option2 = null;
      if (!option3) option3 = null;

      var index = variants.findIndex((object) => {
        return object.option1 === option1 && object.option2 === option2 && object.option3 === option3;
      });

      if (index > -1) {
        var variant = variants[index];
        var quantity = quantities[index];

        $('input[name="id"]', $section).val(variant.id);
        $('input[name="quantity"]', $section).attr('max', quantity);
        $('.productPrice', $section).html(Shopify.formatMoney(variant.price, theme.moneyFormatWithCurrency));

        if (variant.available) {
          $('.productAdd', $section).prop('disabled', false);
          $('.productAddLabel', $section).html('Add to cart');
        } else {
          $('.productAdd', $section).prop('disabled', true);
          $('.productAddLabel', $section).html('Not available');
        }
      }
    },
    appstle: {
      change: function ($section, $option) {
        var price = $('.appstle_subscription_amount', $option).html();
        $('.productPrice', $section).html(price);
      },
    },
    loader: function () {
      $('section.product-detail').each(function () {
        var $section = $(this);
        if ($section) addToCart.change($section);
      });
    },
    trigger: function () {
      $(document).on('click', 'section.product-detail input.productValue', function () {
        var $section = $(this).parents('section.product-detail');
        if ($section) addToCart.change($section);
      });
      $(document).on('click', 'section.product-detail input[name="selling_plan"]', function () {
        var $section = $(this).parents('section.product-detail');
        var $option = $(this).parent();
        if ($option) addToCart.appstle.change($section, $option);
      });
    },
  };

  addToCart.init();

  return output;
};

const sectionCollection = function () {
  var output = {};
  var sort = {
    init: function () {
      sort.loader();
      sort.trigger();
    },
    loader: function () {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },
    trigger: function () {
      $(document).on('change', 'input[name="sortby"]', function (event) {
        console.log('test');
        var $checked = $('[name="sortby"]:checked');
        Shopify.queryParams.sort_by = $checked.val();
        location.search = new URLSearchParams(Shopify.queryParams).toString();
      });
    },
  };
  var filter = {
    init: function () {
      filter.noUiSlider.init();
    },
    noUiSlider: {
      init: function () {
        filter.noUiSlider.loader();
      },
      update: function ($input, values) {
        var $from = $('.slider-from', $input.parent());
        var $to = $('.slider-to', $input.parent());

        if (values[0] > 0 || values[1] < $to.attr('max')) {
          $from.val(values[0]);
          $to.val(values[1]);
        } else {
          $from.val('');
          $to.val('');
        }
      },
      loader: function () {
        $('.slider-input').each(function () {
          var $input = $(this);
          var $from = $('.slider-from', $input.parent());
          var $to = $('.slider-to', $input.parent());

          var start = [$from.val() ? Number($from.val()) : 0, $to.val() ? Number($to.val()) : Number($to.attr('max'))];

          noUiSlider.create(this, {
            start: start,
            connect: true,
            tooltips: {
              to: function (value) {
                console.log(value);
                return Shopify.formatMoney(String(value.toFixed(2)).replace('.', ''), theme.moneyFormatWithCurrency);
              },
            },
            range: {
              min: 0,
              max: Number($to.attr('max')),
            },
          });

          this.noUiSlider.on('update', function (values) {
            filter.noUiSlider.update($input, values);
            console.log();
          });
        });
      },
    },
  };

  sort.init();
  filter.init();

  return output;
};

const sectionLoginMain = function () {
  var output = {};

  var view = {
    init: function () {
      view.loader();
      view.trigger();
    },
    loader: function () {
      var hash = window.location.hash;
      hash = hash ? hash : '#login';
      var views = '#login, #recover';

      $(views).removeClass('active');
      $(hash).addClass('active');
    },
    trigger: function () {
      window.addEventListener('hashchange', function () {
        var hash = window.location.hash;
        hash = hash ? hash : '#login';
        var views = '#login, #recover';

        $(views).removeClass('active');
        $(hash).addClass('active');
      });
    },
  };

  view.init();

  return output;
};

const blockProduct = function () {
  var output = {};
  var addToCart = {
    init: function () {
      addToCart.loader();
      addToCart.trigger();
    },
    change: function ($block) {
      var id = $block.attr('data-id');
      var variants = JSON.parse($('.jsonVariants', $block).html());
      var option1 = $('input[name="' + id + 'option1"]:checked', $block).val();
      var option2 = $('input[name="' + id + 'option2"]:checked', $block).val();
      var option3 = $('input[name="' + id + 'option3"]:checked', $block).val();

      if (!option1) option1 = null;
      if (!option2) option2 = null;
      if (!option3) option3 = null;

      var variant = variants.find((object) => {
        return object.option1 === option1 && object.option2 === option2 && object.option3 === option3;
      });

      if (variant) {
        $('input[name="id"]', $block).val(variant.id);
        $('.productPrice', $block).html(Shopify.formatMoney(variant.price, theme.moneyFormatWithCurrency));
        
        if (variant.available) {
          $('.productAdd', $block).prop('disabled', false);
          $('.productAddLabel', $block).html('Add to cart');
        }
        else
        {
          $('.productAdd', $block).prop('disabled', true);
          $('.productAddLabel', $block).html('Not available');
        }
      }
    },
    submit: function ($block) {
      var data = {
        id: $('input[name="id"]', $block).val(),
        quantity: $('input[name="quantity"]', $block).val(),
      };

      cart.add({ items: [data] }, function (response, statusText, xhr) {
        if (statusText === 'error') {
          if (response.status === 422) notification.add('warning', response.responseJSON.description);
        } else {
          notification.add('success', response.items[0].title + ' has been added to cart');
        }
      });
    },
    loader: function () {
      $('article.product').each(function () {
        var $block = $(this);
        if ($block) addToCart.change($block);
      });
    },
    trigger: function () {
      $(document).on('click', 'article.product .productValue', function () {
        var $block = $(this).parents('article.product');
        if ($block) addToCart.change($block);
      });
      $(document).on('click', 'article.product .productAdd', function () {
        var $block = $(this).parents('article.product');
        if ($block) addToCart.submit($block);
      });
    },
  };

  addToCart.init();

  return output;
};

// --- account addresses
const sectionAddresses = function () {
  // --- change default "---" to "Country/region"
  $('#AddressCountryNew option:first').text('Country/region');
};
const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

var ioBlockProduct = blockProduct();
var ioSectionHeader = sectionHeader();
var ioSectionProduct = sectionProduct();
var ioSectionCollection = sectionCollection();
var ioSectionLoginMain = sectionLoginMain();
var ioSectionAddresses = sectionAddresses();
